
export const CHROME = 'chrome';

export const EDGE = 'edge';

export const OPERA = 'opera';

export const FIREFOX = 'firefox';

export const INTERNET_EXPLORER = 'iexplorer';

export const SAFARI = 'safari';

export const NWJS = 'nwjs';

export const ELECTRON = 'electron';

export const REACT_NATIVE = 'react-native';

export const UNKNOWN = 'unknown';

